// @flow
import { URL_WAG_TAG_TERMS } from '../../constants';

export default [
  {
    label: 'About Wag!',
    links: [
      {
        label: 'Help Center',
        path: 'https://help.wagwalking.com',
      },
      {
        label: 'About Wag!',
        path: 'https://wagwalking.com/about',
      },
      {
        label: 'Trust and Safety',
        path: 'https://wagwalking.com/trust-safety',
      },
      {
        label: 'Community Guidelines',
        path: 'https://wagwalking.com/community-guidelines',
        target: '_blank',
      },
      {
        label: 'Wag! Partners',
        path: 'https://wagwalking.com/partners',
      },
      {
        label: 'Press',
        path: 'https://wagwalking.com/daily/press-releases',
      },
      {
        label: 'Blog',
        path: 'https://wagwalking.com/daily',
      },
      {
        label: 'Careers',
        path: 'https://wagwalking.com/careers',
      },
      {
        label: 'Become Wag! Walker',
        path: 'https://wagwalking.com/dog-walker',
      },
    ],
  },
  {
    label: 'Top Wag! Cities',
    links: [
      {
        label: 'San Francisco',
        path: 'https://wagwalking.com/dog-walking/ca-san-francisco',
      },
      {
        label: 'Los Angeles',
        path: 'https://wagwalking.com/dog-walking/ca-los-angeles',
      },
      {
        label: 'Chicago',
        path: 'https://wagwalking.com/dog-walking/il-chicago',
      },
      {
        label: 'New York',
        path: 'https://wagwalking.com/dog-walking/ny-new-york',
      },
      {
        label: 'Atlanta',
        path: 'https://wagwalking.com/dog-walking/ga-atlanta',
      },
      {
        label: 'Washington D.C.',
        path: 'https://wagwalking.com/dog-walking/dc-washington',
      },
      {
        label: 'Dallas',
        path: 'https://wagwalking.com/dog-walking/tx-dallas',
      },
      {
        label: 'Miami',
        path: 'https://wagwalking.com/dog-walking/fl-miami',
      },
      {
        label: 'Philadelphia',
        path: 'https://wagwalking.com/dog-walking/pa-philadelphia',
      },
      {
        label: 'All Walking Cities',
        path: 'https://wagwalking.com/dog-walking/cities',
      },
      {
        label: 'All Boarding Cities',
        path: 'https://wagwalking.com/dog-boarding/cities',
      },
    ],
  },
  {
    label: 'Resources',
    links: [
      {
        label: 'Dog Health',
        path: 'https://wagwalking.com/care',
      },
      {
        label: 'Dog Training',
        path: 'https://wagwalking.com/training',
      },
      {
        label: 'Dog Grooming',
        path: 'https://wagwalking.com/grooming',
      },
      {
        label: 'Dog Breeds',
        path: 'https://wagwalking.com/breed',
      },
      {
        label: 'Dog Names',
        path: 'https://wagwalking.com/daily/names',
      },
      {
        label: 'Dog Activities',
        path: 'https://wagwalking.com/activities',
      },
      {
        label: 'Dog Senses',
        path: 'https://wagwalking.com/daily/senses',
      },
      {
        label: 'Dog Behavior',
        path: 'https://wagwalking.com/daily/behavior',
      },
    ],
  },
  {
    label: 'Lifestyles',
    links: [
      {
        label: 'Dog Beaches',
        path: 'https://wagwalking.com/lifestyle/beaches',
      },
      {
        label: 'Dog Campgrounds',
        path: 'https://wagwalking.com/lifestyle/campgrounds',
      },
      {
        label: 'Dog Parks',
        path: 'https://wagwalking.com/lifestyle/parks',
      },
      {
        label: 'Dog Trails',
        path: 'https://wagwalking.com/lifestyle/trails',
      },
    ],
  },
  {
    label: 'Legal Links',
    links: [
      {
        label: 'Privacy Policy',
        path: 'https://wagwalking.com/privacy',
      },
      {
        label: 'Terms & Conditions',
        path: 'https://wagwalking.com/terms',
      },
      {
        label: 'Wag! Tag Terms of Service',
        path: URL_WAG_TAG_TERMS,
      },
      {
        label: 'Accessibility',
        path: 'https://wagwalking.com/accessibility',
      },
    ],
  },
  {
    label: 'Security',
    links: [
      {
        label: 'Responsible Disclosure',
        path: 'https://wagwalking.com/responsible-disclosure',
      },
    ],
  },
];
